<template>
  <b-card
    class="nt-card"
    no-body>
    <b-row
      class="title"
      no-gutters>
      <nuxt-link
        v-if="iconLink"
        :class="iconClasses"
        :to="link"
        tag="i"/>
      <i
        v-else
        :class="iconClasses"/>
      <div :class="['align-self-center']"><slot name="header">{{ header }}</slot></div>
    </b-row>
    <b-row no-gutters>
      <b-card-body
        :title="title"
        title-tag="h5"
        class="body p-3">
        <div class="nt-card-content">
          <slot/>
        </div>
      </b-card-body>
    </b-row>
  </b-card>
</template>


<script>
let variantValidator = (value) => {
  return ['danger', 'warning', 'success', 'info'].indexOf !== -1
}

export default {
  props: {
    icon: {
      type: String,
      required: false,
      default: ''
    },
    header: {
      type: String,
      required: false,
      default: ''
    },
    link: {
      type: Object,
      required: false,
      default: () => ({})
    },
    iconLink: {
      type: Boolean,
      required: false,
      default: false
    },
    iconBgVariant: {
      type: String,
      required: false,
      default: 'info',
      validator: variantValidator
    },
    iconTextVariant: {
      type: String,
      required: false,
      default: 'white',
      validator: variantValidator
    },
    iconSize: {
      type: String,
      required: false,
      default: ''
    },
    title: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    iconClasses () {
      return [this.icon, this.iconSize, 'p-3'];
    }
  },
  created() {
    if (this.iconLink && Object.keys(this.link).length === 0 && this.link.constructor === Object) throw Error('Link must be defined when icon-link prop is set')
  }
}
</script>

<style lang="scss" scoped>
$baseFontSize: 30px;

.nt-card-content {
  display: inline-block;
  width: 100%;
}

.fa {font-size: $baseFontSize}

i {
  &.xs {font-size: $baseFontSize * 0.5}
  &.sm {font-size: $baseFontSize * 0.75}
  &.lg {font-size: $baseFontSize * 1.5}
  &.xl {font-size: $baseFontSize * 2}
}
</style>

